// extracted by mini-css-extract-plugin
export default {"sizeXL":"20px","control":"G3db268","left":"G55da3b G6eac61 G3db268","right":"G3769e7 G3db268"};